import { render, staticRenderFns } from "./quit.vue?vue&type=template&id=765a7d0a&scoped=true"
import script from "./quit.vue?vue&type=script&lang=js"
export * from "./quit.vue?vue&type=script&lang=js"
import style0 from "./quit.vue?vue&type=style&index=0&id=765a7d0a&prod&lang=scss&scoped=true"
import style1 from "./quit.vue?vue&type=style&index=1&id=765a7d0a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765a7d0a",
  null
  
)

export default component.exports